import { all, fork } from "redux-saga/effects";
//layout
import LayoutSaga from "./layouts/saga";
//Auth
import AuthSaga from "./auth/login/saga";
import RegisterSaga from "./auth/register/saga";
import DashboardSaga from "./dashboard/saga";
import UserSaga from "./user/saga";
import RoleSaga from "./role/saga";
import ClientSaga from "./client/saga";
import DeviceSaga from "./device/saga";
// import DeviceTypeSaga from "./deviceType/saga";
// import UnitSaga from "./unit/saga";
// import AddressSaga from "./address/saga";
// import FolderSaga from "./folder/saga";
// import FileSaga from "./file/saga";
// import ParameterSaga from "./parameter/saga";
// import SensorSaga from "./sensor/saga";
import HistorySaga from "./history/saga";
// import ReportTemplateSaga from "./reportTemplate/saga";
// import ReportTemplateDetailSaga from "./reportTemplateDetail/saga";
// import UomSaga from "./uom/saga";
// import CompanySaga from "./company/saga";
// import BranchSaga from "./branch/saga";
// import DashboardTemplateSaga from "./dashboardTemplate/saga";
// import DashboardTemplateDetailSaga from "./dashboardTemplateDetail/saga";
// import NotificationSaga from "./notification/saga";

export default function* rootSaga() {
  yield all([
    fork(AuthSaga),
    fork(RegisterSaga),
    fork(UserSaga),
    fork(LayoutSaga),
    fork(DashboardSaga),
    fork(RoleSaga),
    fork(ClientSaga),
    fork(DeviceSaga),
    // fork(DeviceTypeSaga),
    // fork(UnitSaga),
    // fork(AddressSaga),
    // fork(FolderSaga),
    // fork(FileSaga),
    // fork(ParameterSaga),
    // fork(SensorSaga),
    fork(HistorySaga),
    // fork(ReportTemplateSaga),
    // fork(ReportTemplateDetailSaga),
    // fork(UomSaga),
    // fork(CompanySaga),
    // fork(BranchSaga),
    // fork(DashboardTemplateSaga),
    // fork(DashboardTemplateDetailSaga),
    // fork(NotificationSaga),
  ]);
}
